import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AdminManagerService } from "../services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { DwConfigService, DwConfigServiceToken, getParameterByName } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";

@Injectable()
export class PilexosHttpInterceptor implements HttpInterceptor {

    constructor(private adminManagerService: AdminManagerService, private router: Router,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
    ) {

    }

    PILEXOS_USER_TYPE_OVERRIDE = "pilexos-user-type-override";
    PILEXOS_FLIGHT_SCHOOL_ID_OVERRIDE = "pilexos-flight-school-id-override";

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop: string]: string } = {};

        if (!this.adminManagerService.canUseAdminProperties()) {
            return next.handle(request);
        }

        // Only apply to requests that are going to the API
        if (request.url.indexOf(this.configService.coreConfig.apiRoot) == -1) {
            return next.handle(request);
        }

        const pilexosUser = this.adminManagerService.getPilexosUser();

        headers[this.PILEXOS_USER_TYPE_OVERRIDE] = pilexosUser?.UserTypeId?.toString() || '';
        headers[this.PILEXOS_FLIGHT_SCHOOL_ID_OVERRIDE] = pilexosUser?.flightSchoolOrganizationId?.toString() || '';
        
        request = request.clone({
            headers: request.headers,
            setHeaders: headers
        })

        return next.handle(request);
    }
}